import InputInterface from "./InputInterface.ts";
import FormulaInterface from "./FormulaInterface.ts";

export default class CollectionInput implements InputInterface {
    returnType: string;
    values: Array<any>;

    constructor(returnType: string) {
        this.returnType = returnType;
        this.values = [];
    }

    getName(): string {
        throw Error();
    }

    getReturnType(): string {
        return this.returnType;
    }

    getFormula(): FormulaInterface {
        throw Error();
    }

    /**
     * @param index
     * @param input
     */
    addInput(index: number, input: InputInterface): InputInterface {
        throw Error();
    }

    /**
     * @param index
     */
    getInput(index: number): InputInterface {
        throw Error();
    }

    /**
     * @param index
     */
    hasInput(index: number): boolean {
        throw Error();
    }

    /**
     * @param key
     */
    removeInput(key: number): void {
        throw Error();
    }

    serialize(): string {
        throw Error();
    }

    /**
     * @param value
     */
    setValue(value: any): void {
        throw Error();
    }

    /**
     * @param index
     */
    getValue(index): any {
        return this.values[index];
    }

    /**
     * @param value
     */
    addValue(value: any): any {
        this.values.push(value);

        return value;
    }

    getAll(): Array<any> {
        return this.values;
    }

    /**
     * @param index
     */
    hasValue(index): boolean {
        return undefined !== this.values[index];
    }



}


// WEBPACK FOOTER //
// ./src/Models/pricingRulesInterface/CollectionInput.ts